import { createBrowserRouter } from "react-router-dom";
import App from "./App";
import Home from "./screens/Home";
import MyInfo from "./screens/MyInfo";
import LevelLearning from "./screens/LevelLearning";
import FunLearningAlone from "./screens/FunLearningAlone";
import MakeRoom from "./components/MakeRoom";
import EnterCode from "./components/EnterCode";
import ShowCode from "./components/ShowCode";
import PersonalTest from "./components/PersonalTest";
import { io } from "socket.io-client";
import WaitingRoom from "./components/WaitingRoom";
import Room from "./screens/Room";
import ComingSoon from "./screens/ComingSoon";
import ShowRanking from "./components/ShowRanking";
import NotFound from "./components/NotFound";
import CooperativeLearning from "./screens/CooperativeLearning";
import Notice from "./screens/Notice";
import Vokatoktok from "./screens/Vocatoktok";
import Sentencetoktok from "./screens/Sentencetoktok";
import SuccessedWords from "./screens/SuccessedWords";
import LiteracyLearning from "./screens/ LiteracyLearning";
import LiteracyLearningPlay from "./screens/ LiteracyLearningPlay";
import ReadingMain from "./reading/ReadingMain";
import ShowRankingSuccess from "./components/ShowRankingSuccess";
import UsedId from "./screens/UsedId";
import CreateLearning from "./screens/CreateLearning";
import CreateLearningPlay from "./create/CreateLearningPlay";
import MakeCreateLearning from "./create/MakeCreateLearning";
import AddWordsSentencesForm from "./create/AddWordsSentencesForm";

const socket = io("https://uvlqtxcfrh.us14.qoddiapp.com");
// const socket = io("http://localhost:3001");
const router = createBrowserRouter([
  {
    path: "fun_learning/",
    element: <App />,
    children: [
      {
        path: "",
        element: <Notice />,
      },
      {
        path: "usedId",
        element: <UsedId />,
      },
      {
        path: "vocatoktok",
        element: <Vokatoktok />,
      },
      {
        path: "sentencetoktok",
        element: <Sentencetoktok />,
      },
      {
        path: "cooperate",
        element: <CooperativeLearning />,
      },
      {
        path: "successedwords",
        element: <SuccessedWords socket={socket} />,
      },
      {
        path: "home",
        element: <Home socket={socket} />,
      },
      {
        path: "funlearningalone",
        element: <FunLearningAlone />,
      },
      {
        path: "literacylearning",
        element: <LiteracyLearning />,
      },
      {
        path: "literacyplay",
        element: <LiteracyLearningPlay />,
      },
      {
        path: "levellearning",
        element: <LevelLearning />,
      },
      {
        path: "myinfo",
        element: <MyInfo />,
      },
      {
        path: "entercode",
        element: <EnterCode />,
      },
      {
        path: "showcode",
        element: <ShowCode />,
      },
      {
        path: "room",
        element: <Room socket={socket} />,
      },
      {
        path: "waitingRoom",
        element: <WaitingRoom />,
      },
      {
        path: "personaltest",
        element: <PersonalTest />,
      },
      {
        path: "comingsoon",
        element: <ComingSoon />,
      },
      {
        path: "showranking",
        element: <ShowRanking socket={socket} />,
      },
      {
        path: "showrankingsuccess",
        element: <ShowRankingSuccess socket={socket} />,
      },
      {
        path: "reading",
        element: <ReadingMain />,
      },
      {
        path: "createlearning",
        element: <CreateLearning />,
      },
      {
        path: "createbook",
        element: <MakeCreateLearning />,
      },
      {
        path: "startcreatelearning",
        element: <CreateLearningPlay />,
      },
      {
        path: "adddata",
        element: <AddWordsSentencesForm />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
]);

export default router;
